import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { ModalContainerComponent } from '../../../../../../components/modals/modal-container.component';
import { RuleAuditHistoryAction } from '../../../../../../../../shared/constants/rule-audit-history';
import { ErrorMessageService } from '../../../../../../services/error-message.service';
import { CustomValidators } from '../../../../../../services/helpers/form-custom-validators';

@Component({
  styleUrls: ['./issues-bulk-action-modal.component.scss'],
  templateUrl: './issues-bulk-action-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IssuesBulkActionModalComponent {
  private formValidationRequest: Subject<void>;

  @ViewChild(ModalContainerComponent, { static: true }) public container: ModalContainerComponent;
  @Input()
  public actionType: RuleAuditHistoryAction;
  @Input()
  public modalHeader: string;
  @Input()
  public modalTitle: string;
  public confirmed: boolean;

  public modalForm: UntypedFormGroup;
  public formValidationRequest$: Observable<void>;

  public reason: string;
  @Input()
  public ruleTitle: string;
  @Input()
  public hideRuleTitle: boolean = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private errorMessageService: ErrorMessageService,
    private element: ElementRef<Element>,
  ) {
    this.formValidationRequest = new Subject<any>();
    this.formValidationRequest$ = this.formValidationRequest.asObservable();

    this.setUpForm();
  }

  private setUpForm(): void {
    const formConfig: Record<string, UntypedFormControl> = {
      reason: new UntypedFormControl(null, {
        validators: [CustomValidators.required, CustomValidators.validateIsEmpty],
      }),
    };
    this.modalForm = this.formBuilder.group(formConfig);
  }

  public close(): void {
    this.container.closeModal();
  }

  public onFormSubmit(): void {
    this.modalForm.updateValueAndValidity();
    this.formValidationRequest.next();

    if (this.modalForm.valid === false) {
      this.errorMessageService.setFocusOnFirstError(this.element.nativeElement);
      return;
    }

    this.reason = this.modalForm.get('reason').value;

    this.confirmed = true;
    this.close();
  }
}
